import { render, staticRenderFns } from "./Notice.vue?vue&type=template&id=30f20f86&scoped=true"
import script from "./Notice.vue?vue&type=script&lang=js"
export * from "./Notice.vue?vue&type=script&lang=js"
import style0 from "./Notice.vue?vue&type=style&index=0&id=30f20f86&prod&lang=css"
import style1 from "./Notice.vue?vue&type=style&index=1&id=30f20f86&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f20f86",
  null
  
)

export default component.exports